import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function updateRejected(rejectedId, stateSlug) {
  const axios = axiosInstance().primoLab;
  let prescriptionRejected = [];

  await axios
    .put(`/prescription-rejections/${rejectedId}`, {
      action: "update_state",
      state_slug: stateSlug,
    })
    .then(async (response) => {
      prescriptionRejected = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { prescriptionRejected };
}
